import { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import FeeSystemMenu from "./FeeSystemMenu";
import moment from "moment";
import { Modal } from "react-bootstrap";
import * as XLSX from "xlsx";
import MonthsDropDown from "../Shared/MonthsDropDown";
import { Form } from 'react-bootstrap';
import YearsDropDown from "../Shared/YearsDropDown";
import DatePicker from "react-datepicker";
import { registerables } from "chart.js";

function AddInstallments(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [isUpdated, setIsUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [ScrollDated, setScrollDated] = useState("");
  const [DueDate, setDueDated] = useState(moment().format(config.date_format_input));
  const [InstallmentMonth, setInstallmentMonth] = useState(moment().format("MM"));
  const [InstallmentYear, setInstallmentYear] = useState(moment().format("YYYY"));
  const [BenchNo, setBenchNo] = useState("");
  const [InstallmentNo, setInstallmentNo] = useState("");
  const [BarCodeValue, setBarCodeValue] = useState("");
  const [excelData, setExcelData] = useState([]);
  const [lgShow, setLgShow] = useState(false);

  const [Installment_Amount, setInstallment_Amount] = useState("");
  const [RegistrationNo, setRegistrationNo] = useState("");
  const [LoadingFetchLedger, setLoadingFetchLedger] = useState(false);
  const [fileSelected, setfileSelected] = useState(false);

  const [selectedFileName, setSelectedFileName] = useState('');
  const [InstallmentEntry, setInstallmentEntry] = useState([]);
  const [enteredAmounts, setEnteredAmounts] = useState([]);
  const [selectedStudentID, setSelectedStudentID] = useState(0);
  const [StudentDepositedAmount, setStudentDepositedAmount] = useState(0);
  const [BankID, setBankID] = useState(0);
  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10000);
  const [totalRecords, setTotalRecords] = useState(0);
  const [FineAmount, setFineAmount] = useState("");
  const [StruckOffFine, setStruckOffFine] = useState("");
  const [studentvalidated, setstudentvalidated] = useState(false);
  const [loadingUpdateBtn, setLoadingUpdateBtn] = useState(false);

  useEffect(() => {
    document.title = "Add Installments";
    setIsUpdated(false);
    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      RegistrationNo: RegistrationNo,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Installment/GetInstallmentsForStudent",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        // console.log(response.data);
        if (response.data.status_code == 1) {
          setLedger(response.data.ListofRecords);

          setLoading(false);
          setTotalRecords(response.data.totalRecords);
        }
        else {
          setLedger([]);
        }
        setLoading(false);
      })
      .catch(function (error) {
        //////console.log(error);
      });
  }, [pageNo, pageSize, isUpdated, RegistrationNo]);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)} </td>
            <td>{item.RegNo}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Installment_Number}</td>
            <td>{moment(item.Month_Number).format("MMM")}</td>
            <td>{item.Current_Year}</td>
            <td>{moment(item.Due_Date).format("DD/MM/YYYY")}</td>
            <td className="text-center">{item.Installment_Amount}</td>
            {/* <td>{item.Balance_After_This_Entry}</td>
            <td>{item.Balance_Type_After_This_Entry}</td> */}
            <td className="text-center">
              <ul
                className="inline-action"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <button
                    onClick={(e) => EditEntry(item.ID, item.Amount)}
                    className="green"
                  >
                    <i className="ri-edit-line"></i>
                  </button>
                </li>
                <li>
                  <button
                    onClick={(e) => deleteEntry(item.ID)}
                    className="red"
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </li>
              </ul>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="10">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  const deleteEntry = (ID) => {
    const result = window.confirm("Are you sure you want to delete?");

    if (result) {

      const data = {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType,
        ID: ID,
      };

      var api_config = {
        method: "post",
        url: config.base_url + "Installment/DeleteInstallmentRule",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          ////////console.log(response.data);
          if (response.data.status_code == 1) {
            setIsUpdated(true);
            toast.success(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          // setIsUpdated(false);
        })
        .catch(function (error) {
          //////console.log(error);
        });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet,
        {
          raw: false,
          dateNF: 'DD/MM/YYYY',
        }
      );
      setfileSelected(true);
      setExcelData(jsonData);
      setSelectedFileName(file.name); // Set the selected file name here
    };

    reader.readAsArrayBuffer(file);
  }

  useEffect(() => {
    const day = moment(ScrollDated).format("DD");
    if (day > 6 && day < 21) {
      const DayDiff = day - 6;
      setFineAmount(50 * DayDiff);
    }
    else {
      setFineAmount(0)
    }
  }, [ScrollDated])

  const handleSubmit = () => {
    setLoading(true);

    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      MemberType: MemberType,
      RegNo: RegistrationNo,
      Installment_Number: InstallmentNo,
      Installment_Amount: Installment_Amount,
      Due_Date: DueDate,
      Month_Number: InstallmentMonth,
      Current_Year: InstallmentYear
    };

    // console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "Installment/AddInstallment",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        ////////console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
          setBarCodeValue("");
        } else if (response.data.status_code == 0 || response.data.status_code == 2) {

          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT
          });
          setLoading(false);
          setIsUpdated(false);
        }
        // setIsUpdated(false);
      })
      .catch(function (error) {
        //////console.log(error);
      });


    setInstallment_Amount("");
    setRegistrationNo("")
    setStruckOffFine("")
  };

  const handleSubmitByFile = () => {
    excelData.forEach((row) => {
      const data = {
        UserID: UserID,
        AccessKey: AccessKey,
        MemberType: MemberType,
        RegNo: row.REGISTRATION_NO,
        Installment_Number: row.NO_OF_INSTALLMENTS,
        Installment_Amount: row.PACKAGE_AMOUNT
      };

      //////console.log(data);

      var api_config = {
        method: "post",
        url: config.base_url + "Installment/AddInstallmentsByPackage",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(api_config)
        .then(function (response) {
          ////////console.log(response.data);
          if (response.data.status_code == 1) {
            setIsUpdated(true);
            setBarCodeValue("");
            setfileSelected(false);
            setSelectedFileName('');
          } else if (response.data.status_code == 0 || response.data.status_code == 2) {

            toast.error(response.data.status_message, {
              position: toast.POSITION.TOP_RIGHT
            });
            setLoading(false);
            setIsUpdated(false);
          }
        })
        .catch(function (error) {
          //////console.log(error);
        });
    });
  };

  const EditEntry = (ID, Amount) => {
    GetInstallmentByID(ID);
    setSelectedStudentID(ID);
    setStudentDepositedAmount(Amount);
    setLgShow(true)
  }

  const GetInstallmentByID = (ID) => {
    setLoadingFetchLedger(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: ID,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Installment/GetInstallmentRuleByID",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        // console.log(response.data);
        if (response.data.status_code == 1) {
          setInstallmentEntry(response.data.InstallmentRule);
          setLoadingFetchLedger(false)
          setInstallmentNo(response.data.InstallmentRule.Installment_Number);
          setInstallmentMonth(response.data.InstallmentRule.Month_Number);
          setInstallmentYear(response.data.InstallmentRule.Current_Year);
          setDueDated(moment(response.data.InstallmentRule.Due_Date).toDate());
          setInstallment_Amount(response.data.InstallmentRule.Installment_Amount);
        }
        else {
          setLoadingFetchLedger(false)
        }
      })
      .catch(function (error) {
        //////console.log(error);
        setLoadingFetchLedger(false)
      });
  }

  const handleUpdateLedger = (e) => {
    e.preventDefault();
    setLoadingUpdateBtn(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ID: selectedStudentID,
      Installment_Number: InstallmentNo,
      Month_Number: InstallmentMonth,
      Current_Year: InstallmentYear,
      Due_Date: moment(DueDate).format("YYYY-MM-DD"),
      RegNo: InstallmentEntry.RegNo,
      Installment_Amount: Installment_Amount,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "Installment/UpdateInstallment",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(api_config)
      .then(function (response) {
        ////////console.log(response.data);
        if (response.data.status_code == 1) {
          setIsUpdated(true);
          setLgShow(false);
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setInstallmentNo("");
          setInstallmentMonth("");
          setInstallmentYear("");
          setDueDated("");
          setStudentDepositedAmount(0);
          setInstallment_Amount("");
          setLoadingUpdateBtn(false);
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoadingUpdateBtn(false);
      })
      .catch(function (error) {
        //////console.log(error);
        setLoadingUpdateBtn(false);
      });
  }

  return (
    <>
      <Modal
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Installment Entry
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={studentvalidated}
            onSubmit={handleUpdateLedger}
          >
            <div style={{ padding: "20px" }}>
              <div className="form-group mb-3 d-flex flex-column">
                <label>Installment No</label>
                <input
                  type="number"
                  defaultValue={InstallmentEntry.Installment_Number}
                  name="InstallmentNo"
                  className="form-control"
                  required
                  onChange={(e) => setInstallmentNo(e.target.value)}
                />

              </div>
              <div className="form-group mb-3">
                <label>Installment Month</label>
                <select
                  className="form-select"
                  onChange={(e) => setInstallmentMonth(e.target.value)}
                >
                  <option value="">Please Select</option>
                  <MonthsDropDown />
                </select>
              </div>
              <div className="form-group mb-3">
                <label>Installment Year</label>
                <select
                  className="form-select"
                  onChange={(e) => setInstallmentYear(e.target.value)}
                >
                  <option value="">Please Select</option>
                  <YearsDropDown />
                </select>
              </div>
              <div className="form-group mb-3 d-flex flex-column">
                <label>Due Date</label>
                <DatePicker
                  selected={moment(InstallmentEntry.DueDate).toDate()}
                  dateFormat="dd/MM/yyyy"
                  className="form-control"
                  required
                  name="PostingDate"
                  onChange={(date) => setDueDated(date)}
                />
              </div>
              <div className="form-group mb-3">
                <label>Installment Amount</label>
                <input
                  type="number"
                  defaultValue={InstallmentEntry.Installment_Amount}
                  name="Installment_Amount"
                  className="form-control"
                  onChange={(e) => setInstallment_Amount(e.target.value)}
                  required
                />
              </div>

              {loadingUpdateBtn ? (
                <div className="text-center">
                  <Spinner animation="border" role="status"></Spinner>
                </div>
              ) : (
                <button type="submit" className="button button-primary w-100">
                  UPDATE
                </button>
              )}
            </div>
          </Form>
        </Modal.Body>

      </Modal >

      <FeeSystemMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">
                        Fee System
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Add Installments
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Add Installments</div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <div className="container">
            <div>
              <div className="card mb-4">
                <div className="card-body p-4">
                  <div className="row align-items-center">

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Installment Month:</label>
                        <select
                          className="form-select"
                          onChange={(e) => setInstallmentMonth(e.target.value)}
                        >
                          <option value="">Please Select</option>
                          <MonthsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Installment Year:</label>
                        <select
                          className="form-select"
                          onChange={(e) => setInstallmentYear(e.target.value)}
                        >
                          <option value="">Please Select</option>
                          <YearsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Due Date:</label>
                        <input
                          type="date"
                          className="form-control"
                          onChange={(e) => setDueDated(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="card">
                <div className="card-body">
                  <table className="table table-theme table-sm table-sticky">
                    <thead>
                      <tr>
                        <th>S No</th>
                        <th>Registration No</th>
                        <th>Student Name</th>
                        <th>Installment No</th>
                        <th>Month</th>
                        <th>Year</th>
                        <th>Due Date</th>
                        <th>Installment Amount</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    {
                      loading ?
                        <div className="text-center">
                          <Spinner animation="border" role="status"></Spinner>
                        </div> :
                        renderLedger()
                    }
                  </table>
                </div>
              </div>
            </div>

            <div className="card mt-2">
              <div className="card-body p-4">
                <div className="row align-items-center gy-3">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label >Installment No:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={InstallmentNo}
                        onChange={(e) => setInstallmentNo(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Student Code:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={RegistrationNo}
                        onChange={(e) => setRegistrationNo(e.target.value)}
                        name="RegistrationNo"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Amount:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={Installment_Amount}
                        onChange={(e) => setInstallment_Amount(e.target.value)}
                        name="Installment_Amount"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-2 offset-md-4">
                    <button
                      type="button"
                      onClick={handleSubmit}
                      disabled={Installment_Amount == "" || RegistrationNo == ""}
                      className={`button button-primary w-100
                       ${Installment_Amount == "" || RegistrationNo == ""
                          ? "disabled"
                          : ""
                        }`}
                    >
                      Add Entry
                    </button>
                  </div>
                  <div className="col-md-10  text-end">
                    {selectedFileName && <span style={{ fontSize: "13px", marginRight: "10px" }}>Selected file: {selectedFileName}</span>}
                    <label htmlFor="chose-file" className="button button-white shadow-sm" style={{ cursor: "pointer" }}><i className="ri-upload-2-line"></i> Chose File
                      <input
                        className="" id="chose-file"
                        style={{
                          opacity: "0",
                          zIndex: "-1",
                          visibility: "hidden",
                          position: "absolute"
                        }}
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={handleFileChange}
                      />
                    </label>
                  </div>
                  <div className="col-md-2">
                    <button
                      type="button"
                      onClick={handleSubmitByFile}
                      disabled={!fileSelected}
                      className={`button button-primary w-100
                       ${!fileSelected ? "disabled" : ""}`}
                    >
                      Add Enteries
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddInstallments;